{
  "app_loading": "Connecting to hideout network...",
  "layout_brand": "NederFall",
  "layout_subtitle": "Hideout",
  "nav_hub": "Hideout",
  "nav_people": "Survivors",
  "nav_trips": "Trips",
  "nav_stash": "Stash",
  "nav_quests": "Journal",
  "auth_intro": "It is 2040 in the Netherlands. The government has fallen and society has collapsed. Most have left but those who remain try to survive in the harsh environment that has remained of what was once a well-faring country full of culture and tradition.",
  "auth_google": "Continue with Google",
  "auth_description": "Progress is saved to your account.",
  "auth_redirecting": "Redirecting...",
  "account_back": "Back",
  "account_header_account": "Account",
  "account_logged_in_as": "Signed in as",
  "account_google_hint": "Google account management is in your Google account settings.",
  "account_sync_title": "Cloud sync",
  "account_status_label": "Status:",
  "account_status_error_prefix": "Error:",
  "account_status_ok": "Active",
  "account_status_syncing": "Working...",
  "account_last_sync": "Last sync:",
  "account_never_synced": "Not synced yet",
  "account_upload": "Upload changes",
  "account_pull_cloud": "Reload from cloud",
  "account_settings_title": "Settings",
  "account_language": "Language",
  "account_language_note": "Switch between Dutch and English for the full UI and in-game copy (items, locations, events, etc.).",
  "account_lang_nl": "Nederlands",
  "account_lang_en": "English",
  "account_notifications": "Notifications",
  "account_notifications_desc": "Get notifications for expedition returns, quests, and other events.",
  "account_notifications_blocked": "Could not enable notifications. Check browser or permission settings.",
  "account_sound": "Sound",
  "account_sound_desc": "Short UI and expedition sound cues.",
  "account_theme": "Theme",
  "account_theme_desc": "Switch to light mode.",
  "account_help_title": "Help",
  "account_help_1": "Send survivors on trips from the Trips tab.",
  "account_help_2": "Supplies and workstations live on Hub and Stash.",
  "account_help_3": "Sync issues: try “Reload from cloud” or sign out and back in.",
  "account_about_title": "About",
  "account_about_body": "NederFall: Hideout is an idle/management game set in the NederFall universe (collapsed Netherlands, 2040). You run a small hideout in Brabant, send survivors on timed scavenging expeditions, manage needs and inventory, build and upgrade workstations, learn skills, and grow camp capability over time..",
  "account_sign_out": "Sign out",
  "account_header_btn": "Account",
  "account_btn_title": "Account and settings",
  "hideout_stat_idle": "Stand-by",
  "hideout_stat_missions": "Away",
  "hideout_stat_lowest": "Lowest",
  "hideout_workstations": "Workstations",
  "hideout_build_card_title": "Build ",
  "hideout_build_card_sub": "Uses stash materials · tap for options",
  "hideout_build_card_count": "{{count}} not built yet",
  "hideout_build_card_available": "{{count}} available to build",
  "hideout_build_ready_hint": "Enough materials to build at least one station",
  "hideout_build_ready_chip": "Ready",
  "hideout_build_ready_badge": "{{count}} ready",
  "hideout_build_modal_title": "Build a workstation",
  "hideout_build_modal_hint": "Costs are paid from your stash when you confirm.",
  "hideout_build_modal_empty": "Nothing left to build here.",
  "hideout_quick": "Quick",
  "hideout_send_out": "Send them out",
  "hideout_survivors": "Survivors",
  "hideout_ready_suffix": "ready",
  "hideout_total_suffix": "total",
  "hideout_flavor": "The shelter groans. Nobody says it, but everyone waits for something that never comes.",
  "hideout_flavor_neutral_01": "Rain taps the sheet metal in a rhythm nobody talks over.",
  "hideout_flavor_neutral_02": "Someone tightened the same bolt twice today. It still rattles.",
  "hideout_flavor_neutral_03": "You listen for wings or tires—anything that says the world moved.",
  "hideout_flavor_food_low_01": "We're almost out of food. Portions hover near polite fiction.",
  "hideout_flavor_food_low_02": "The tins feel lighter every morning; nobody asks what's left.",
  "hideout_flavor_water_low_01": "We're running out of water—empty bottles stand like bad omens.",
  "hideout_flavor_water_low_02": "The water count keeps shrinking; voices stay careful around the jug.",
  "hideout_flavor_food_high_01": "For once the stash feels generous—food stacked like small victories.",
  "hideout_flavor_food_high_02": "Plenty of tins tonight; you catch yourself relaxing around the shelf.",
  "hideout_flavor_water_high_01": "Water isn't the worry right now—there's enough to share without counting.",
  "hideout_flavor_water_high_02": "Jugs and bottles line up; thirst feels far away today.",
  "hideout_flavor_solo_01": "Alone here, every echo answers twice.",
  "hideout_flavor_solo_02": "I could use someone to talk to.",
  "hideout_flavor_duo_01": "Two survivors now; it almost feels like you found a friend.",
  "hideout_flavor_duo_02": "Company changes the math—watch shifts, meals, hope split down the middle.",
  "hideout_flavor_rural_map_01": "You're starting to find your way around out there—the lanes feel familiar.",
  "hideout_flavor_rural_map_02": "South of the river isn't a blur anymore; landmarks stick.",
  "hideout_flavor_den_bosch_01": "Den Bosch is opening up—your reach stretches toward taller streets.",
  "hideout_flavor_den_bosch_02": "The city's edges aren't hypothetical anymore; routes bite deeper inward.",
  "hideout_flavor_bike_01": "A bike in the rack changes distance—you imagine slipping between patrols.",
  "hideout_flavor_bike_02": "Two wheels mean excuses vanish; errands suddenly sound doable.",
  "hideout_flavor_car_01": "Keys on a hook that shouldn't exist—a car changes how far \"far\" is.",
  "hideout_flavor_car_02": "Metal shell and fuel scent: dangerous luxury, honest mobility.",
  "hideout_flavor_pair_01": "{{a}} and {{b}} argue softly over watch hours—trust with sharp timing.",
  "hideout_flavor_pair_02": "{{a}} traded a joke with {{b}}; laughter lasted longer than planned.",
  "hideout_flavor_pair_03": "{{a}} checks {{b}}'s kit without asking; habits sync like gear teeth.",
  "hideout_flavor_pair_04": "{{b}} lent {{a}} dry socks—small solidarity, loudly quiet.",
  "hideout_flavor_gaming_01": "{{name}} stares at dead outlets and misses their old console.",
  "hideout_flavor_gaming_02": "{{name}} describes a speedrun like scripture—muscle memory without hardware.",
  "hideout_flavor_gaming_03": "{{name}} hums a boss theme while stacking scrap; old reflexes die hard.",
  "exp_heading_active": "Away",
  "exp_none_caption": "Nobody is out. The city waits.",
  "exp_remaining_one": "{{count}} trip left",
  "exp_remaining_many": "{{count}} trips left",
  "exp_progress": "{{done}}/{{need}} trips completed",
  "exp_no_survivors": "Nobody available",
  "exp_send_out": "Start trip",
  "exp_slots_full": "All trip slots in use",
  "exp_send_disabled_idle": "Nobody on standby — check Survivors or wait for returns.",
  "exp_send_disabled_full": "All expedition slots full — finish trips first.",
  "exp_possible_loot": "Possible loot",
  "exp_exploration": "Exploration",
  "exp_exploration_unexplored": "Unexplored",
  "exp_exploration_fully_explored": "Fully explored",
  "exp_den_bosch_quest_gate_hint": "Open your Quest log and start Road to the city to scout Den Bosch. Completing it reveals your first destination.",
  "explore_to_reveal": "Explore to reveal",
  "surv_title": "Survivors",
  "surv_roster_cap": "{{current}}/{{max}} capacity",
  "surv_hint": "Tap a survivor to view their full profile.",
  "stash_empty": "The storeroom is empty. Send someone scavenging.",
  "stash_trinkets": "Trinkets",
  "stash_total_value": "Total value:",
  "stash_points": "pts",
  "assign_send_title": "Send {{name}} out",
  "assign_pick_destination": "Pick a destination. The trip costs reserves.",
  "assign_cancel": "Cancel",
  "assign_send": "Send",
  "assign_loot_yield_pct": "{{sign}}{{pct}}% extra loot",
  "vehicle_loot_pct": "{{sign}}{{pct}}% loot",
  "assign_who_goes": "Who goes to {{place}}?",
  "assign_no_idle": "Nobody is ready. Everyone is busy.",
  "assign_at_workstation": "Assigned to {{name}}",
  "assign_recruit_retry_hint": "You met a survivor at this location before. Do you want to look for them again? They might reconsider.",
  "assign_recruit_retry_toggle": "Look for {{name}} again",
  "status_working": "Working",
  "assign_needs_line": "{{hunger}} {{hungerVal}} · {{thirst}} {{thirstVal}} · {{energy}} {{energyVal}}",
  "ws_sheet_all_away": "Everyone is away.",
  "ws_sheet_injured": "Injured",
  "ws_sheet_heal_note": "Dress wound → Idle",
  "toast_back": "{{name}} back",
  "toast_nothing": "nothing found",
  "exp_card_away": "{{name}} away",
  "exp_card_unknown": "???",
  "gems_label": "Gems",
  "exp_skip_half_time_title": "Use 1 gem to skip half the remaining wait time",
  "event_heading": "Event",
  "workstation_available": "{{count}} available",
  "workstation_insufficient": "Insufficient",
  "workstation_locked": "Locked",
  "workstation_unbuilt": "Not built",
  "workstation_cost_line": "−1 {{cat}} · +{{restore}} {{need}}",
  "cat_food_short": "food",
  "cat_water_short": "water",
  "cat_scrap_short": "scrap",
  "cat_weapon_short": "weapon",
  "cat_meds_short": "meds",
  "cat_trinket_short": "trinket",
  "need_hunger_short": "hunger",
  "need_thirst_short": "thirst",
  "need_energy_short": "energy",
  "need_hunger": "Hunger",
  "need_thirst": "Thirst",
  "need_energy": "Energy",
  "moral_delta": "Energy",
  "assign_cost_hunger": "Hunger −{{v}}",
  "assign_cost_thirst": "Thirst −{{v}}",
  "assign_cost_energy": "Energy {{v}}",
  "status_idle": "Idle",
  "status_onmission": "Away",
  "status_injured": "Injured",
  "status_resting": "Resting",
  "role_scavenger": "Scavenger",
  "role_medic": "Medic",
  "role_cook": "Cook",
  "equipment_weapon": "Weapon",
  "equipment_tool": "Tool",
  "equipment_empty_hands": "Empty hands",
  "equipment_no_tool": "No tool",
  "resource_strip_food": "Food",
  "resource_strip_water": "Water",
  "resource_strip_scrap": "Scrap",
  "resource_strip_meds": "Med.",
  "resource_strip_survivors": "Survivors",
  "skill_stealth": "Stealth",
  "skill_note_looting": "Find more loot.",
  "skill_note_stealth": "Save energy.",
  "skill_note_endurance": "Save hunger and thirst.",
  "skill_guns": "Guns",
  "skill_melee": "Melee",
  "skill_heavy_weapons": "Heavy weapons",
  "skill_explosives": "Explosives",
  "skill_archery": "Archery",
  "skill_cybernetics": "Cybernetics",
  "skill_looting": "Looting",
  "skill_first_aid": "First aid",
  "skill_survival": "Survival",
  "skill_endurance": "Endurance",
  "skill_animal_training": "Animal training",
  "skill_navigation": "Navigation",
  "skill_fishing": "Fishing",
  "skill_climbing": "Climbing",
  "skill_parkour": "Parkour",
  "skill_swimming": "Swimming",
  "skill_lockpicking": "Lockpicking",
  "skill_programming": "Programming",
  "skill_engineering": "Engineering",
  "skill_electronics": "Electronics",
  "skill_tinkering": "Tinkering",
  "skill_bartering": "Bartering",
  "skill_persuasion": "Persuasion",
  "skill_linguistics": "Linguistics",
  "skill_charisma": "Charisma",
  "skill_construction": "Construction",
  "skill_crafting": "Crafting",
  "skill_cooking": "Cooking",
  "skill_agriculture": "Agriculture",
  "skill_gaming": "Gaming",
  "skill_art": "Art",
  "skill_music": "Music",
  "skill_driving": "Driving",
  "onboarding_continue": "Continue",
  "onboarding_survivor_label": "Survivor",
  "cc_title": "Your survivor",
  "cc_blurb": "Name them and spend six bonus points on core skills before the story continues.",
  "cc_name_label": "Name",
  "cc_name_placeholder": "Survivor name",
  "cc_portrait_label": "Portrait",
  "cc_gender_label": "Presentation",
  "cc_gender_unspecified": "Prefer not to say",
  "cc_gender_female": "Female",
  "cc_gender_male": "Male",
  "cc_gender_nonbinary": "Other",
  "cc_skills_title": "Attributes",
  "cc_points_remaining": "{{count}} points left",
  "cc_skip_intro": "You already have a roster. Continue the opening without changing survivors?",
  "cc_skip_continue": "Continue to intro",
  "account_replay_tutorial": "Replay tutorial",
  "account_reset_section": "Danger zone",
  "account_reset_hint": "Clear all shelter progress on this device and in the cloud. Your login and preferences stay the same.",
  "account_reset_first": "Reset progress",
  "account_reset_confirm_prompt": "Tap again to confirm. This cannot be undone.",
  "account_reset_final": "Progress wiped",
  "account_reset_cancel": "Cancel",
  "account_install_app_title": "Install app",
  "account_install_app_button": "Install on this device",
  "account_install_app_desc": "Add this game to your home screen for a full-screen experience without the browser bar.",
  "account_install_app_unavailable": "Already installed or not supported by this browser.",
  "coach_label": "Coach",
  "coach_first_trip_title": "First trip",
  "coach_first_trip_body": "Go to Trips and send someone to the Bridge to Vinkel. The first run is extra short.",
  "coach_first_return_title": "Wait for return",
  "coach_first_return_body": "Your first expedition takes around 20 seconds. Once the toast appears, the tutorial continues.",
  "coach_workstation_title": "Use a workstation",
  "coach_workstation_body": "Check the toast and stash. Open Kitchen or Water point in the Hub and care for someone.",
  "coach_cta_understood": "Understood",
  "coach_cta_waiting": "Waiting",
  "coach_cta_continue": "Continue",
  "quests_heading": "Quest log",
  "quests_intro": "Stories with tasks. Completing some quests grants rewards or unlocks later — others are just survival.",
  "quests_collapsed_objectives": "{{done}}/{{total}} objectives",
  "quests_collapsed_complete_short": "Completed",
  "quests_starter_tag": "Survival",
  "quest_starter_survival_title": "Make it through the first night",
  "quest_starter_survival_body": "You are all alone. If you want to survive, you need some help. Scout out the village and bring back some supplies.",
  "quest_starter_inactive": "Available after the opening scenes.",
  "quest_starter_complete": "You cleared the basics. The shelter remembers.",
  "quest_starter_reward": "Reward: 20 gems.",
  "quest_phase_send_bridge": "Scout out the village",
  "quest_phase_return_loot": "Bring back some supplies",
  "quest_phase_build_campfire": "Build the campfire",
  "quest_phase_feed_hunger": "Cook yourself some food",
  "quests_den_bosch_tag": "Gateway",
  "quest_den_bosch_gateway_title": "Road to the city",
  "quest_den_bosch_gateway_body": "Rural South is mapped out — Den Bosch waits beyond it. Prove you're stocked enough before risking the streets.",
  "quest_den_bosch_gateway_start_hint": "Objectives count only after you begin — tap Start when you're ready.",
  "quest_start_button": "Start quest",
  "quest_den_bosch_obj_farm": "Complete a trip to the abandoned farm ({{current}} / {{need}})",
  "quest_den_bosch_obj_food": "Collect {{need}} food value from expedition loot after starting ({{current}} / {{need}})",
  "quest_den_bosch_obj_water": "Collect {{need}} water value from expedition loot after starting ({{current}} / {{need}})",
  "quest_den_bosch_obj_farm_label": "Trip to the abandoned farm",
  "quest_den_bosch_obj_food_label": "Collect food from expeditions",
  "quest_den_bosch_obj_water_label": "Collect water from expeditions",
  "quest_den_bosch_gateway_complete": "The city's periphery is open.",
  "quest_den_bosch_gateway_reward": "Your first 's-Hertogenbosch destination is now available under Trips.",
  "quests_utrecht_tag": "Utrecht",
  "quest_utrecht_gateway_title": "North corridor — Utrecht",
  "quest_utrecht_gateway_body": "The northern highway is a gamble: you need a stronger hideout and a working signal before Utrecht opens up. Take it one step at a time.",
  "quest_utrecht_gateway_start_hint": "Tap Start when you are ready — objectives unlock in order. Den Bosch’s four inner-city sites must be fully explored first.",
  "quest_utrecht_phase_find_radio": "Find a survivor radio",
  "quest_utrecht_phase_find_radio_detail": "Your camp is still too quiet. Scout the A2 corridor and salvage a broken radio from the collapsed rest stop — you will need parts before anyone answers.",
  "quest_utrecht_phase_repair_radio": "Repair the radio in the Workshop",
  "quest_utrecht_phase_repair_radio_detail": "Use the workshop recipe that turns scrap-radio-broken into a working scrap-radio (wire and electronics help).",
  "quest_utrecht_phase_build_broadcast": "Build the Communication center",
  "quest_utrecht_phase_build_broadcast_detail": "Erect the broadcast station — the initial build consumes your working scrap-radio and ties the mast into the network.",
  "quest_utrecht_phase_north_supply": "Reach out and haul supplies north",
  "quest_utrecht_phase_north_supply_detail": "With the mast live: recruit more survivors through the broadcast, then bring home scrap and electronics from expeditions to stock the push toward Utrecht.",
  "quest_utrecht_obj_broadcast_label": "Build Communication center",
  "quest_utrecht_obj_recruit_label": "Recruit survivors (excludes Trader recruits)",
  "quest_utrecht_obj_scrap_label": "Scrap value after broadcast",
  "quest_utrecht_obj_electronics_label": "Electronics value after broadcast",
  "quest_utrecht_gateway_complete": "Utrecht is on the map.",
  "quest_utrecht_gateway_reward": "Dom square is available under Trips — the canal chain unlocks from there.",
  "exp_a2_quest_gate_hint": "Open Journal → start the Utrecht corridor quest to unlock the highway.",
  "exp_utrecht_quest_gate_hint": "Finish the Utrecht corridor quest to unlock the city.",
  "role_trader": "Trader",
  "ws_detail_market_section": "Trading run",
  "ws_detail_market_blurb": "Assign a Trader, then run a timed route for stash credits (€). Tap again when the timer finishes to collect.",
  "ws_detail_market_run": "Start trading run",
  "ws_detail_market_running": "Trader away…",
  "ws_detail_market_claim": "Collect payout",
  "ws_detail_training_section": "Training yard",
  "ws_detail_training_blurb": "Assign someone idle, then run an endurance circuit. XP arrives automatically when the timer ends.",
  "ws_detail_training_start": "Start training circuit",
  "ws_detail_training_running": "Training… {{time}} left",
  "ws_detail_computer_section": "Terminal slots",
  "ws_detail_computer_blurb": "Install salvaged hardware per slot, assign an operator, then start a hack job. Stash € and electronics resolve automatically when each timer finishes.",
  "ws_detail_computer_slot_label": "Slot {{n}}",
  "ws_detail_computer_hardware": "Hardware",
  "ws_detail_computer_slot_empty": "Empty bench",
  "ws_detail_computer_operator": "Operator",
  "ws_detail_computer_no_operator": "Nobody assigned",
  "ws_detail_computer_start": "Start hack job",
  "ws_detail_computer_running": "Running… {{time}} left",
  "recipes_title": "Recipes",
  "recipes_active_job": "A craft is already running on this station.",
  "recipes_unlock_at": "Unlocks after {{count}} completed expeditions",
  "recipes_close": "Close",
  "stash_filter_all": "All",
  "stash_filter_food": "Food",
  "stash_filter_water": "Water",
  "stash_filter_meds": "Meds",
  "stash_filter_scrap": "Scrap",
  "stash_filter_weapons": "Weapons",
  "stash_filter_trinkets": "Trinkets",
  "stash_search_placeholder": "Search item...",
  "stash_sort_rarity": "rarity",
  "stash_sort_name": "name",
  "stash_sort_quantity": "quantity",
  "stash_capacity_label": "Stash capacity",
  "stash_capacity_warning": "Stacks {{current}} / {{cap}} — make room or upgrade stash.",
  "stash_keep": "Keep",
  "stash_keep_locked": "Locked",
  "stash_use": "Use",
  "stash_use_feed_title": "Feed with {{item}}",
  "stash_use_hydrate_title": "Hydrate with {{item}}",
  "stash_use_treat_title": "Treat with {{item}}",
  "stash_use_less_effect_note": "Stash use gives less satisfaction than workstation care.",
  "stash_use_food_effect_note": "Eating from stash gives less satisfaction than using a campfire or kitchen.",
  "stash_use_water_effect_note": "Drinking from stash gives less satisfaction than using a water point.",
  "stash_use_meds_effect_note": "Medicine from the stash only treats injured survivors (clears the wound timer).",
  "stash_weapon_equip_title": "Equip {{item}}",
  "stash_weapon_equip_note": "Pick who should equip this weapon.",
  "stash_weapon_current": "Current",
  "stash_weapon_damage_change": "{{current}} -> {{next}} dmg",
  "stash_drop": "Drop",
  "stash_discard_selected": "Discard selection ({{count}})",
  "stash_detail_rarity": "Rarity",
  "stash_detail_category": "Category",
  "stash_detail_value": "Value",
  "stash_balance": "Balance",
  "surv_profile_progress": "Profile progression",
  "surv_xp_line": "XP {{current}}/{{required}}",
  "surv_achievements": "{{count}} milestones",
  "detail_extra_skills": "Learned extra skills",
  "detail_skill_books": "Books and manuals",
  "detail_no_skill_books": "No skill books in stash.",
  "detail_learn_skill": "Learn {{skill}}",
  "detail_skill_already_unlocked": "Already unlocked",
  "detail_consume_book": "Consumes 1 book",
  "detail_survivor_progress": "Survivor progression",
  "detail_survivor_level": "Level {{level}}",
  "detail_survivor_xp": "XP {{current}}/{{required}}",
  "detail_survivor_max_level": "Max level reached",
  "workstation_open_recipes": "Open recipes",
  "detail_not_found": "Not found.",
  "detail_back": "Back",
  "detail_needs": "Needs",
  "detail_skills": "Skills",
  "detail_loadout": "Loadout",
  "detail_expedition_cost": "Trip costs",
  "detail_loadout_note": "Weapons are taken from stash; equipping removes one from stock and returns it when unequipped.",
  "detail_weapon_equip": "Equip",
  "detail_weapon_swap": "Swap",
  "detail_weapon_unequip": "Unequip",
  "detail_weapon_sheet_title": "Equip weapon from stash",
  "detail_weapon_sheet_note": "Pick a weapon and preview damage change.",
  "detail_weapon_sheet_empty": "No weapons in stash.",
  "detail_weapon_bow_locked": "Requires Archery (learn from a book).",
  "detail_weapon_effective": "{{effective}} dmg (base {{base}}, skill multiplier)",
  "ws_assign_kitchen_need_cooking": "Nobody here has Cooking yet. Find a cookbook on an expedition.",
  "detail_cost_discount_note": "Discounts come from Stealth and Strength.",
  "detail_send": "Send on expedition",
  "detail_unavailable": "Unavailable",
  "cost_abbr_h": "H",
  "cost_abbr_d": "D",
  "cost_abbr_m": "M",
  "hideout_tier_label": "Hideout",
  "hideout_relocate_section": "Move hideout",
  "hideout_relocate_progress": "Trips completed: {{current}} / {{need}} required",
  "hideout_relocate_btn_short": "Move hideout",
  "ws_detail_level_line": "Level {{level}}",
  "ws_detail_unbuilt": "Not built",
  "ws_detail_build_section": "First build",
  "ws_detail_build_cta": "Build station",
  "ws_detail_build_tier_gate": "Requires hideout tier: {{tier}}",
  "ws_detail_upgrade_section": "Upgrade",
  "ws_detail_upgrade_cta": "Upgrade station",
  "ws_detail_upgrade_max_tier": "At max level for this hideout — relocate to raise the cap.",
  "ws_detail_upgrade_next": "Next: level {{level}}",
  "ws_detail_no_upgrade": "No further upgrade path",
  "ws_detail_assign_section": "Assignment",
  "ws_detail_assigned": "Assigned",
  "ws_detail_working": "Working",
  "ws_detail_unassigned": "Nobody assigned",
  "ws_detail_assign_button": "Assign or change worker",
  "ws_detail_assign_placeholder": "Assign a worker for role bonuses.",
  "ws_detail_offers_section": "What this station offers",
  "ws_detail_offers_empty": "No summary available.",
  "ws_detail_offer_stash_bullet": "Stash stack cap at this level: ~{{cap}} unique stacks.",
  "ws_detail_offer_stash_next": "Next station level ({{level}}): ~{{cap}} stacks.",
  "ws_detail_offer_hub_bullet": "Up to {{count}} expeditions can run at once from this hideout.",
  "ws_detail_offer_restore_bullet": "Care restores {{need}} over time — about +{{amount}} per visit.",
  "ws_detail_offer_restore_heal_bullet": "Legacy copy — injuries use meds at the infirmary.",
  "ws_detail_offer_injury_bullet": "Treat injuries with meds — clears timed wounds.",
  "ws_detail_offer_lodging_roster": "Shelter raises roster cap to {{cap}} survivors.",
  "ws_detail_offer_lodging_rest": "{{used}}/{{max}} beds · +{{rate}} energy/min while resting.",
  "ws_detail_offer_broadcast": "Up to {{max}} pending radio contacts. ~{{minutes}} min between contacts with an operator.",
  "ws_detail_lodging_section": "Rest",
  "ws_detail_lodging_leave": "Leave bed",
  "ws_detail_lodging_rest_here": "Rest here",
  "ws_detail_lodging_can_rest": "Survivors who can rest here",
  "ws_detail_injury_empty": "Nobody needs treatment right now.",
  "ws_detail_broadcast_pending_empty": "No pending radio contacts.",
  "ws_detail_injury_section": "Treat injuries",
  "ws_detail_broadcast_section": "Radio contacts",
  "ws_detail_broadcast_accept": "Recruit",
  "ws_detail_broadcast_deny": "Send away",
  "ws_detail_broadcast_roster_note": "Roster {{current}}/{{cap}}",
  "ws_detail_offer_restore_kitchen_bullet": "Eating at the campfire restores about {{amount}} hunger.",
  "ws_detail_offer_restore_well_bullet": "Drinking at the water point restores about {{amount}} thirst.",
  "ws_detail_offer_passive_regen_bullet": "Restores {{need}} by {{rate}} per minute for survivors not on missions.",
  "ws_detail_offer_generator_bullet": "Produces supplies every ~{{minutes}} min (stores {{cap}} items).",
  "ws_detail_offer_generator_worker_required": "Assign a survivor to start generation.",
  "ws_detail_offer_generator_worker_skill": "Assigned survivor skill reduces production cooldown.",
  "ws_detail_offer_craft_bullet": "Craft scrap into gear and supplies using recipes.",
  "ws_detail_generator_section": "Generated supplies",
  "ws_detail_generator_empty": "No items generated yet.",
  "ws_detail_generator_needs_worker": "Assign a survivor to begin generating items.",
  "ws_detail_generator_claim_all": "Claim all",
  "ws_detail_generator_hint": "{{count}} / {{cap}} claimable items stored. Current cooldown: ~{{minutes}} min.",
  "ws_detail_tools_section": "Tools and add-ons",
  "ws_detail_tool_installed": "Installed",
  "ws_detail_tool_install": "Install",
  "ws_detail_tool_effect_restore": "+{{n}} bonus restoration on care",
  "ws_detail_tool_effect_craft": "~{{pct}}% faster crafts",
  "ws_detail_actions": "Actions",
  "ws_detail_stash_cap": "Stash stack cap at this level: ~{{cap}} unique stacks.",
  "ws_detail_stash_cap_arrow": "Upgrade raises cap: {{from}} → {{to}} stacks.",
  "ws_detail_care_section": "Care",
  "ws_detail_care_section_kitchen": "Restore hunger (costs 1 food)",
  "ws_detail_care_section_well": "Restore thirst (costs 1 water)",
  "ws_detail_gem_heal_cta_full": "FULL RESTORE {{cost}} ◆",
  "ws_detail_gem_heal_cta_infirmary": "CLEAR ALL INJURIES ({{cost}} ◆)",
  "ws_detail_gem_heal_need_gems": "Requires {{cost}} gems.",
  "ws_detail_gem_heal_cooldown": "Gem heal on cooldown: {{minutes}} min remaining.",
  "ws_detail_restore_preview": "Restores +{{amount}} (tools & assignee included)",
  "ws_detail_quote_not_hungry": "I'm not hungry",
  "ws_detail_quote_not_thirsty": "I'm not thirsty",
  "ws_detail_quote_not_hurt": "I don't need treatment",
  "ws_detail_craft_section": "Crafting",
  "ws_detail_craft_preview": "Recipes turn scrap into gear; higher level & tools speed this up.",
  "ws_detail_assign_sheet_title": "Who works here?",
  "ws_detail_assign_clear": "Clear assignment",
  "ws_upgrade_title": "Upgrade to level {{level}}",
  "ws_upgrade_requires_tier": "Requires hideout at least",
  "ws_upgrade_tier_blocked": "Relocate to a better hideout to meet this requirement.",
  "ws_upgrade_cap_blocked": "This station is at the max level for your current location.",
  "ws_upgrade_costs": "Cost",
  "ws_upgrade_confirm": "Confirm upgrade",
  "ws_upgrade_cannot": "Cannot upgrade (requirements or materials)",
  "sync_err_stale_session": "Your account is no longer in the database — often after a DB reset while still signed in. Sign out and sign in again with Google.",
  "sync_err_generic": "Sync failed.",
  "exp_heading_returned": "Returned",
  "exp_click_to_collect": "Click to collect",
  "exp_report_ready": "Trip report ready",
  "exp_report_ready_with_name": "Trip report ready · {{name}}",
  "exp_returned_from_location": "{{name}} returned from {{location}}",
  "exp_trip_report_label": "Trip report",
  "exp_trip_report_title": "Claim expedition rewards",
  "exp_trip_report_survivor": "Scout: {{name}}",
  "exp_trip_report_now": "just now",
  "exp_trip_report_needs": "Need changes",
  "exp_trip_report_loot": "Collected items",
  "exp_trip_report_completed_title": "Completed trip to {{location}}",
  "exp_trip_report_loot_yield_team_label": "Team",
  "exp_trip_report_loot_yield_vehicle_label": "Vehicle",
  "exp_trip_report_loot_needs_warning": "Watch your survivor's needs",
  "exp_trip_report_keep": "Keep",
  "exp_trip_report_discarded": "Discard",
  "exp_trip_report_found_survivor": "Possible survivor found",
  "exp_trip_report_recruit_yes": "Recruit",
  "exp_trip_report_recruit_no": "Send away",
  "exp_trip_report_roster_full": "Shelter is full ({{cap}} survivors). Send them away or upgrade lodging.",
  "exp_trip_report_complete": "Complete",
  "exp_trip_report_location_unlocked_title": "Location unlocked",
  "exp_trip_report_location_unlocked_item": "Unlocked: {{location}}",
  "exp_trip_report_location_unlocked_popup_title": "LOCATION UNLOCKED",
  "exp_trip_report_location_unlocked_popup_location": "{{location}}",
  "exp_trip_report_location_unlocked_popup_confirm": "Confirm",
  "exp_trip_report_found_vehicle": "Vehicle found",
  "exp_trip_report_vehicle_no_garage": "No garage built — cannot store vehicle.",
  "exp_trip_report_vehicle_garage_full": "Not enough garage slots for this vehicle — make space first.",
  "exp_trip_report_vehicle_scrap_hint": "Hub → Garage: scrap a parked vehicle to free slots. You can still finish this report without storing the find.",
  "exp_trip_report_manage_garage": "Manage garage",
  "exp_trip_report_manage_garage_title": "Free a parking slot",
  "exp_trip_report_manage_garage_body": "Scrap a vehicle that is not out on a trip. When enough slots are free, you can store this find from the report below.",
  "exp_trip_report_manage_garage_close": "Done",
  "exp_trip_report_manage_garage_scrap": "Scrap…",
  "exp_trip_report_manage_garage_confirm_scrap": "Confirm scrap",
  "exp_trip_report_vehicle_all_on_mission": "Every vehicle in the garage is out on a trip — wait for a return or finish without storing.",
  "exp_trip_report_vehicle_store": "Store: yes",
  "exp_trip_report_vehicle_discard": "Store: no",
  "garage_section_title": "Garage",
  "garage_empty": "No vehicles in the garage. Find one on a trip.",
  "garage_slots_line": "Parking slots: {{used}} / {{max}}",
  "garage_slots_legend": "Small = 1 slot · Medium = 2 · Large = 4. Upgrade the garage for more space.",
  "garage_over_capacity_hint": "Over capacity — scrap something in the Hub to rebalance.",
  "garage_scrap_btn": "Scrap",
  "garage_scrap_popup_title": "Scrap vehicle",
  "garage_scrap_yield_label": "Salvage:",
  "garage_scrap_confirm": "Confirm scrap",
  "garage_scrap_cancel": "Cancel",
  "garage_repair_btn": "Repair ({{scrap}} scrap → +{{pct}}%)",
  "garage_durability": "Durability",
  "assign_vehicle_label": "Take a vehicle",
  "assign_vehicle_none": "No vehicle",
  "assign_vehicle_seat_hint": "If you bring a vehicle, there must be space for everyone.",
  "assign_not_enough_seats": "NOT ENOUGH SEATS",
  "assign_vehicle_passenger_seats": "{{count}} seats",
  "exp_card_away_team": "{{leader}} +{{count}} away",
  "exp_trip_report_team": "{{leader}} +{{count}} more",
  "quests_vehicle_tag": "Vehicles",
  "quest_vehicle_title": "Wheels for the wasteland",
  "quest_vehicle_body": "After the Den Bosch gateway plan is done, follow up on the rumour: an old bike on the abandoned farm. Wheels make runs faster and loot heavier — if you have garage space.",
  "quest_phase_build_garage": "Build the Garage workstation in the Hub.",
  "quest_phase_farm_expedition": "Run an expedition to the Abandoned farm — something should turn up.",
  "quest_garage_recheck": "Check garage",
  "quest_vehicle_complete": "First vehicle secured. The garage is open for business.",
  "quest_vehicle_reward": "Bikes can now drop on any expedition. Vehicles add a loot bonus, use garage slots by size, lose durability per trip — repair with scrap or scrap them for parts.",
  "quest_cooking_skill_tag": "Shelter",
  "quest_cooking_skill_title": "First cook in the kitchen",
  "quest_cooking_skill_body": "A third pair of hands means it is time to get organised. Books teach skills — and a trained cook in the kitchen makes every meal count.",
  "quest_cooking_phase_find_book": "Find a copy of Book: Home cooking",
  "quest_cooking_phase_learn_skill": "Teach the cooking skill to a survivor",
  "quest_cooking_phase_assign_kitchen": "Assign a cook to the kitchen workstation",
  "quest_cooking_complete": "The kitchen is staffed. Meals count for more now.",
  "quest_cooking_reward": "Reward: 20 gems.",
  "stash_book_teach": "Teach",
  "stash_book_teach_title": "Teach {{skill}} from {{item}}",
  "stash_book_teach_note": "Pick a survivor to learn this skill. The book will be consumed.",
  "stash_book_already_known": "Already knows this skill",
  "quest_hideout_move_tag": "Hideout",
  "quest_hideout_move_title": "Find a better base",
  "quest_hideout_move_body": "The forest camp has served you well, but you need more space and better facilities. Scout the abandoned farm, then relocate your hideout to a proper workspace — and upgrade the Base Station to get the most out of it.",
  "quest_hideout_move_phase_farm_trip": "Complete a trip to the Abandoned Farm",
  "quest_hideout_move_phase_relocate": "Use the 'Move hideout' button on the Base Station",
  "quest_hideout_move_phase_upgrade_base": "Upgrade the Base Station to level 2",
  "quest_hideout_move_complete": "Your operation has a real home now.",
  "quest_hideout_move_reward": "Reward: 20 gems. Your new hideout supports higher-level workstations.",
  "journal_tab_quests": "Quests",
  "journal_tab_milestones": "Milestones",
  "milestone_first_100_food_collected_title": "Hoarder",
  "milestone_first_100_food_collected_desc": "Collected 100 food from expeditions.",
  "milestone_first_den_bosch_trip_title": "City Scout",
  "milestone_first_den_bosch_trip_desc": "Completed your first trip to 's-Hertogenbosch.",
  "milestone_first_5_crafts_title": "Hands-on",
  "milestone_first_5_crafts_desc": "Completed 5 crafting jobs.",
  "milestone_out_the_door_title": "Out the Door",
  "milestone_out_the_door_desc": "Sent your first team out into the field.",
  "milestone_strength_in_numbers_title": "Strength in Numbers",
  "milestone_strength_in_numbers_desc": "Recruited a third survivor into your shelter.",
  "milestone_full_house_title": "Full House",
  "milestone_full_house_desc": "Recruited five survivors.",
  "milestone_on_four_wheels_title": "Road Ready",
  "milestone_on_four_wheels_desc": "Found your first vehicle — slowly filling up the garage.",
  "milestone_new_home_title": "New Home",
  "milestone_new_home_desc": "Moved your shelter for the first time.",
  "milestone_signal_found_title": "Signal Found",
  "milestone_signal_found_desc": "Built the field radio — useful for the broadcast desk and milestones.",
  "milestone_water_bearer_title": "Water Bearer",
  "milestone_water_bearer_desc": "Collected 100 water from expeditions.",
  "milestone_workshop_regular_title": "Workshop Regular",
  "milestone_workshop_regular_desc": "Completed 25 crafting jobs.",
  "milestone_street_wise_title": "Street-Wise",
  "milestone_street_wise_desc": "Completed 10 expeditions to 's-Hertogenbosch.",
  "milestone_blooded_title": "Blooded",
  "milestone_blooded_desc": "Had a survivor get injured on an expedition.",
  "milestone_progress_label": "Progress",
  "milestone_unlocked_toast": "Milestone unlocked: {{name}}",
  "milestone_locked_label": "Locked",
  "milestone_claim_button": "Claim reward",
  "milestone_claimed_label": "Reward claimed",
  "tutorial_label": "Tutorial",
  "tutorial_next": "Got it",
  "tutorial_finish": "Let's go",
  "tutorial_hideout_resources_title": "Your hideout",
  "tutorial_hideout_resources_body": "Track survivors, food, water, scrap, and meds here. Run out and things go south fast.",
  "tutorial_hideout_workstations_title": "Workstations",
  "tutorial_hideout_workstations_body": "Build stations to unlock crafting and resource production. More become available as you progress.",
  "tutorial_nav_tabs_title": "Navigation",
  "tutorial_nav_tabs_body": "Use these tabs to move between areas of your shelter.",
  "tutorial_survivors_list_title": "Your survivors",
  "tutorial_survivors_list_body": "Everyone in your group lives here. Check their status, needs, and skills before sending them out.",
  "tutorial_stash_items_title": "The stash",
  "tutorial_stash_items_body": "Everything you find ends up here. You start with some food and water — use them to satisfy hunger and thirst after trips.",
  "tutorial_expeditions_locations_title": "Expeditions",
  "tutorial_expeditions_locations_body": "Send your survivors out to scavenge. Explore locations fully to unlock new areas with better loot.",
  "tutorial_quests_quest_title": "Your first quest",
  "tutorial_quests_quest_body": "Quests guide you through the game. Your first one explains the basics — start there.",
  "tutorial_quests_milestones_title": "Milestones",
  "tutorial_quests_milestones_body": "Reach milestones to earn gems. Claim them here when they unlock.",
  "vehicle_detail_title": "Vehicle",
  "vehicle_detail_buffs": "Buffs",
  "vehicle_detail_parts": "Parts",
  "vehicle_detail_durability": "Durability",
  "vehicle_detail_status": "Status",
  "vehicle_detail_on_trip": "On trip",
  "vehicle_detail_idle": "Idle",
  "vehicle_detail_loot": "loot",
  "vehicle_detail_seat": "seat",
  "vehicle_detail_trip_time_short": "trip time",
  "vehicle_detail_wear_short": "wear",
  "vehicle_part_maxed": "Maxed",
  "vehicle_part_upgrade_cta": "Upgrade to Lv {{level}}",
  "vehicle_part_upgrade_on_trip_disabled": "Upgrade disabled while on trip",
  "garage_auto_repair_hint": "Auto-repair: +{{rate}} durability per minute"
}
